import { Dispatch, SetStateAction, useEffect, useState } from 'react';

export const useInterpolate = (
  start: number,
  end: number,
  duration: number,
  ticksPerSecond = 10
): [number, Dispatch<SetStateAction<number>>] => {
  const millisecondsPerTick = 1000 / ticksPerSecond;
  const [value, setValue] = useState(start);
  const step = (end - start) / (duration / millisecondsPerTick);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setValue((prevValue) => {
        const nextValue = prevValue + step;
        if ((step > 0 && nextValue >= end) || (step < 0 && nextValue <= end)) {
          clearInterval(intervalId);
          return end;
        }
        return nextValue;
      });
    }, millisecondsPerTick);

    return () => clearInterval(intervalId);
  }, [start, end, duration, step, millisecondsPerTick]);

  return [value, setValue];
};
